module.exports = __webpack_public_path__ + "static/media/logo_login.b5dfc0ee.png";